import { getField, updateField } from 'vuex-map-fields'
import api from '@/lib/api'
import { IN_PROGRESS, COMPLETE, ERROR } from '@/lib/constants/actionStatuses'
import { PATH_PLACEMENT_GOALS } from '@/lib/constants/api'
import updateStatus from '@/store/helpers/updateStatus'
import { notifyError, notifySuccess } from '@/lib/notifications'
import buildInitialState from '@/store/helpers/buildInitialState'
import { hideProgressModal, showProgressModal } from '@/lib/progressModal'

let currentYear = new Date().getFullYear()

const placementGoals = {
  namespaced: true,
  state: buildInitialState({
    placementGoals: [
      { year: currentYear, month: 1, goal: 0, netGoal: 0 },
      { year: currentYear, month: 2, goal: 0, netGoal: 0 },
      { year: currentYear, month: 3, goal: 0, netGoal: 0 },
      { year: currentYear, month: 4, goal: 0, netGoal: 0 },
      { year: currentYear, month: 5, goal: 0, netGoal: 0 },
      { year: currentYear, month: 6, goal: 0, netGoal: 0 },
      { year: currentYear, month: 7, goal: 0, netGoal: 0 },
      { year: currentYear, month: 8, goal: 0, netGoal: 0 },
      { year: currentYear, month: 9, goal: 0, netGoal: 0 },
      { year: currentYear, month: 10, goal: 0, netGoal: 0 },
      { year: currentYear, month: 11, goal: 0, netGoal: 0 },
      { year: currentYear, month: 12, goal: 0, netGoal: 0 }
    ]
  }),
  getters: {
    getField
  },
  mutations: {
    updateField,
    updateStatus,
    setPlacementGoals: (state, placementGoals) => {
      state.placementGoals = placementGoals
    },
    clearPlacementGoals (state, year = null) {
      if (!year) {
        year = new Date().getFullYear()
      }
      state.placementGoals = [
        { year: year, month: 1, goal: 0, netGoal: 0 },
        { year: year, month: 2, goal: 0, netGoal: 0 },
        { year: year, month: 3, goal: 0, netGoal: 0 },
        { year: year, month: 4, goal: 0, netGoal: 0 },
        { year: year, month: 5, goal: 0, netGoal: 0 },
        { year: year, month: 6, goal: 0, netGoal: 0 },
        { year: year, month: 7, goal: 0, netGoal: 0 },
        { year: year, month: 8, goal: 0, netGoal: 0 },
        { year: year, month: 9, goal: 0, netGoal: 0 },
        { year: year, month: 10, goal: 0, netGoal: 0 },
        { year: year, month: 11, goal: 0, netGoal: 0 },
        { year: year, month: 12, goal: 0, netGoal: 0 }
      ]
    }
  },
  actions: {
    getPlacementGoals: ({ commit, dispatch }, year = new Date().getFullYear()) => {
      commit('updateStatus', { status: IN_PROGRESS })
      showProgressModal({ dispatch, message: 'Getting placement goals, please wait...' })

      return api.doGet({ path: PATH_PLACEMENT_GOALS, parameters: { Year: year } })
        .then(json => json.data)
        .then(placementGoals => {
          commit('updateStatus', { status: COMPLETE })
          if (placementGoals && placementGoals.length > 0) {
            commit('setPlacementGoals', placementGoals)
          } else {
            commit('clearPlacementGoals', year)
          }
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
          commit('clearPlacementGoals', year)
          notifyError(dispatch, 'Unable to select placement goals')
        })
        .finally(() => {
          hideProgressModal({ dispatch })
        })
    },
    savePlacementGoals: ({ commit, dispatch }, placementGoals) => {
      commit('updateStatus', { status: IN_PROGRESS })
      showProgressModal({ dispatch, message: 'Saving placement goals, please wait...' })

      return api.doPost({ path: PATH_PLACEMENT_GOALS, data: placementGoals })
        .then(response => {
          commit('updateStatus', { status: COMPLETE })

          if (!response.data) {
            throw new Error('Unable to save placement goals.')
          }

          notifySuccess(dispatch, 'Placement goals saved')
          return response.data
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
          notifyError(dispatch, 'Unable to save placement goals')

          throw error
        })
        .finally(() => {
          hideProgressModal({ dispatch })
        })
    }
  }
}

export default placementGoals
